export default "__VITE_ASSET__CrKFVZx4__"